<template>
    <b-card no-body>
        <b-card-header class="border-0">
            <b-row >
                <b-col cols="6">
                    <h3 class="mb-0">
                        <base-button v-show="$route.params.customer_id" type="primary" icon size="sm" @click.prevent="showAllfinancialProposalList()">Show All List</base-button>
                    </h3>
                </b-col>
            </b-row>
        </b-card-header>
        <b-col cols="12" class="d-flex justify-content-center align-items-center justify-content-sm-between">
            <base-input
                label="Search"
                v-model="searchQuery"
                v-on:input="debouncedHandler"
                prepend-icon="fas fa-search"
                placeholder="Search...(case-sensitive)"
                disabled
            >
            </base-input>
            <base-input label="Filters">
                <el-select v-model="filterBy" filterable placeholder="Select Filter By" disabled>
                    <el-option Selected disabled value="x">-- Please Select Filter By --</el-option>
                    <el-option v-for="option in filterOptions" :key="option.doc_type_name" :label="option.doc_type_name" v-bind:value="option.doc_type_id">
                    </el-option>
                </el-select>
            </base-input>
        </b-col>
        <el-table 
            class="table-responsive align-items-center table-flush"
            header-row-class-name="thead-light"
            stripe
            ref="multipleTable"
            :data="queriedData"
            @sort-change="sortChange"
            @selection-change="selectionChange"
            row-key="id"
        >
            <el-table-column
                type="selection"
                width="55"
            >
            </el-table-column>

            <el-table-column 
                label="Name/ID"
                prop="name"
                min-width="150px"
                sortable
            >
                <template v-slot="{row}">
                    <b>{{row.name}}</b>
                </template>
            </el-table-column>

            <el-table-column 
                label="Active Cases"
                prop="name"
                min-width="120px"
                sortable
            >
                <template v-slot="{row}">
                    <b>{{row.cases}}</b>
                </template>
            </el-table-column>

            <el-table-column 
                label="Active Proposal"
                prop="name"
                min-width="125px"
                sortable
            >
                <template v-slot="{row}">
                    <b>{{row.proposal}}</b>
                </template>
            </el-table-column>

            <el-table-column 
                label="Agent/Advisor"
                prop="name"
                min-width="120px"
                sortable
            >
                <template v-slot="{row}">
                    <b>{{row.agent_name}}</b>
                    <b>{{row.advisor_name}}</b>
                </template>
            </el-table-column>

            <el-table-column 
                label="Net Income/Commitment(DSR)"
                prop="name"
                min-width="180px"
                sortable
            >
                <template v-slot="{row}">
                    <b>{{row.net_income}}</b>
                </template>
            </el-table-column>

            <el-table-column 
                label="Created/Updated"
                prop="name"
                min-width="150px"
                sortable
            >
                <template v-slot="{row}">
                    <b>{{row.created_at}}</b>
                </template>
            </el-table-column>
        </el-table>
        <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
            <div class="d-flex align-items-center">
                <p class="card-category mb-0 text-secondary">
                    Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
        
                    <span v-if="selectedRows.length">
                        &nbsp; &nbsp; {{selectedRows.length}} rows selected
                    </span>
                </p>

                <span class="mb-0 ml-4">Rows:</span>

                <el-select
                    class="select-primary pagination-select mx-2"
                    v-model="pagination.perPage"
                    placeholder="Per page"
                    disabled
                >
                    <el-option
                        class="select-primary"
                        v-for="item in pagination.perPageOptions"
                        :key="item"
                        :label="item"
                        :value="item"
                    >
                    </el-option>
                </el-select>
    
            </div>
            <base-pagination
                class="pagination-no-border"
                :current="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="total"
                @change="paginationChanged($event)"
            >
            </base-pagination>
        </div>
    </b-card>
</template>
<script>
    import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown, Tooltip, Select, Option } from 'element-ui'
    import { BasePagination } from '@/components'
    import clientPaginationMixin from '@/assets/js/clientPaginationMixin'
    import notifyFunctionMixin from '@/assets/js/notifyFunctionMixin.js'
    import debounce from 'lodash.debounce'

    export default {
        name: 'customer-profile-listing-joint-table',
         mixins: [notifyFunctionMixin,clientPaginationMixin],
        components: {
            BasePagination,
            [Select.name]: Select,
            [Option.name]: Option,
            [Tooltip.name]: Tooltip,
            [Table.name]: Table,
            [TableColumn.name]: TableColumn,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
        },
        data() {
            return {
                propsToSearch:[],
                tableData: [],
                currentPage: 1,
                mode: 'listing',
                selectedRows: [],
                searchText: '',
                debouncedHandler: '',
                TableColumn:[{
                    type: 'selection'
                }],
                selects: {
                    filter: [],
                },
                filterOptions:[],
                filterBy: ''
            }
        },
        methods: {
            selectionChange(selectedRows) {
                this.selectedRows = selectedRows
            },
        }
    }
</script>